<template>
  <div
    data-testid="shop-category-form"
    class="flex min-h-[100px] w-full cursor-pointer flex-col items-center rounded-lg border border-main bg-surface p-2 pr-6 hover:bg-state-hover-neutral tablet:h-20 tablet:flex-row"
  >
    <div class="w-16"><img src="" alt="" /></div>
    <div class="flex w-full flex-col items-center justify-between gap-1 tablet:flex-row">
      <div>
        <h2 class="txt-headline-m text-main">{{ title }}</h2>
        <p class="txt-body-s-regular text-subtle">{{ copy }}</p>
      </div>
      <a data-testid="shop-category-form-cta" class="btn-outline-neutral-xs mt-2 shrink-0 tablet:mt-0" :href="url" target="_blank"
        >{{ cta }}
        <ExternalLinkIcon class="ml-1 lucide-icon-s" />
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ExternalLinkIcon } from '@ramp106/omrjs-core-ui/icons'
defineProps<{
  title: string
  copy: string
  cta: string
  url: string
}>()
</script>
